import { createProvider } from '@js/providers/providerFactory.js';

let cachedProvider = null;

async function getSearchspringProvider() {
  if (window.search?.provider !== 'searchspring') return null;
  if (window._arcSearchspringBeaconProvider) return window._arcSearchspringBeaconProvider;
  if (cachedProvider) return cachedProvider;

  cachedProvider = await createProvider('searchspring');
  return cachedProvider;
}

export function initSearchspringBeaconBridge() {
  if (window._arcBeaconBridgeInitialized) return;
  window._arcBeaconBridgeInitialized = true;

  window.addEventListener('arc:beacon:impression', async (event) => {
    const provider = await getSearchspringProvider();
    if (provider?.sendBeaconImpressionEvent) {
      provider.sendBeaconImpressionEvent(
        event.detail?.responseId,
        event.detail?.tag,
        event.detail?.results
      );
    }
  });

  window.addEventListener('arc:beacon:clickthrough', async (event) => {
    const provider = await getSearchspringProvider();
    if (provider?.sendBeaconClickthroughEvent) {
      provider.sendBeaconClickthroughEvent(
        event.detail?.responseId,
        event.detail?.tag,
        event.detail?.uid,
        event.detail?.parentId
      );
    }
  });
}
